(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    function step(track) {
      var first = track.children[0];
      if (!first) {
        return track.clientWidth * 0.9;
      }
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function init(root) {
      if (root.dataset.carouselReady === 'true') {
        return;
      }
      root.dataset.carouselReady = 'true';

      var track = root.querySelector('[data-carousel-track]');
      if (!track) {
        return;
      }
      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');

      function update() {
        var overflow = track.scrollWidth - track.clientWidth > 1;
        var max = track.scrollWidth - track.clientWidth - 1;
        if (prev) {
          prev.hidden = !overflow || track.scrollLeft <= 0;
        }
        if (next) {
          next.hidden = !overflow || track.scrollLeft >= max;
        }
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -step(track), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: step(track), behavior: 'smooth' });
        });
      }
      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', function () {
        window.requestAnimationFrame(update);
      });
      update();
    }

    function initAll() {
      document.querySelectorAll('[data-carousel]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["particles"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }
    const container = document.getElementById('particles');
    if (!container) {
      return;
    }
    const count = 40;
    for (let i = 0; i < count; i++) {
      const p = document.createElement('div');
      p.className = 'particle';
      const size = Math.random() * 3 + 1;
      p.style.cssText = `
        width: ${size}px;
        height: ${size}px;
        left: ${Math.random() * 100}%;
        bottom: ${Math.random() * 60}%;
        animation-duration: ${Math.random() * 12 + 8}s;
        animation-delay: ${Math.random() * 10}s;
        opacity: 0;
      `;
      container.appendChild(p);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["reveal-on-scroll"] && !Shopify.designMode) return;
  try {
    (function () {
    const triggers = document.querySelectorAll('.reveal-on-scroll-trigger[data-reveal-target]');
    if (!triggers.length) {
      return;
    }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }
    const selectors = new Set();
    triggers.forEach((t) => {
      const sel = t.dataset.revealTarget;
      if (sel) {
        selectors.add(sel);
      }
    });
    if (!selectors.size) {
      return;
    }
    const observed = new WeakSet();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, i) => {
          if (entry.isIntersecting) {
            window.setTimeout(() => {
              entry.target.style.opacity = '1';
              entry.target.style.transform = 'translateY(0)';
            }, i * 80);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll([...selectors].join(',')).forEach((el) => {
      if (observed.has(el)) {
        return;
      }
      observed.add(el);
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
      observer.observe(el);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
